<div class="mybet-taxation-info" *ngIf="isVisible">
    <div class="mybet-taxation-info_text" [innerHTML]="taxationHelpText | msTrust: 'html'" (click)="openTaxationHelp()"></div>
    <div class="mybet-taxation-info_ok_text" (click)="close()">{{ sitecore.betslip.editBet.infoConfirm }}</div>
</div>
